import { MenuItemData } from '@components/Navigation';
import { mc, StyleProps } from '@styles';
import React, { FC, MouseEventHandler } from 'react';

import ChevronRightIcon from './assets/chevronRight.inline.svg';

interface Props extends StyleProps {
  item: MenuItemData;
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
  onClose?: () => void;
}

export const NavigationTailsViewDropdown: FC<Props> = ({ className, style, item, onMouseEnter, onMouseLeave, onClose }) => {
  const { description, items } = item;

  return (
    <div
      className={mc('bg-light-gray px-4 py-10', 'flex flex-row items-center justify-center', className)}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="flex flex-1 flex-col w-full max-w-[1290px]">
        {!!description && (
          <div className="px-4 text-lg italic font-sharpsans leading-normal tracking-wide font-semibold text-ocean-blue">
            {description}
          </div>
        )}
        {items && items.length > 0 && (
          <div className="flex flex-row flex-wrap my-1">
            {items.map(itm => (
              <a
                key={itm.title}
                className="block my-2"
                style={{ width: '33%' }}
                href={itm.url || item.url || '#'}
                onClick={onClose}
              >
                <span
                  className={mc(
                    'px-6 mx-4 h-20 rounded-lg',
                    'flex flex-row justify-start items-center',
                    'text-ocean-blue bg-white stroke-ocean-blue',
                    'hover:bg-ocean-blue hover:text-white hover:stroke-white',
                  )}
                >
                  {!!itm.icon && <div className="mr-4 w-10 h-10 flex justify-center items-center">{itm.icon}</div>}
                  <span className="flex flex-1 flex-row justify-between items-center">
                    <span className="block text-xl font-raleway leading-normal text-center">{itm.title}</span>
                    <ChevronRightIcon height={16} />
                  </span>
                </span>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export type NavigationTailsViewDropdownProps = Props;
export default NavigationTailsViewDropdown;
